import { Button } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { Header } from '@tom-ui/ui'
import { PATHS } from '@tom-ui/utils'
import { useNavigate } from 'react-router'

export const AllocationRulesTemplateHeader = () => {
  const { t } = useTranslate()
  const navigate = useNavigate()
  const title = t('allocationRulesTemplates', 'Allocation rules templates')

  const breadcrumbs = [
    { label: t(PATHS.masterData.title), route: PATHS.masterData.url },
    { label: title },
  ]

  return (
    <Header
      title={title}
      position='relative'
      breadcrumbs={breadcrumbs}
      rightRenderOption={
        <Button
          sx={{ flex: 'none' }}
          variant='contained'
          onClick={() => navigate('new')}
          data-cy='add-allocation-rule-template-btn'
        >
          {t('addNewAllocationRuleTemplate', 'Add new allocation rule template')}
        </Button>
      }
    />
  )
}
